import React from "react";
import PropTypes from "prop-types";
import { LinearProgress } from "@material-ui/core";
import { Formik, Form as FormikForm } from "formik";
import Button from "components/common_components/Button";
import Icon from "components/common_components/Icon";

function Form({ children, onCancel, title, maxWidth, showButtons, id, ...props }) {
    return (
        <>
            {title && <h2>{title}</h2>}
            <Formik {...props}>
                {(form) => (
                    <FormikForm id={id}>
                        {typeof children === "function" ? children(form) : children}
                        {showButtons && (
                            <div className="button-group">
                                <Button
                                    outline
                                    onClick={() => {
                                        form.resetForm();
                                        onCancel(form);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button primary type="submit" loading={form.isSubmitting}>
                                    <Icon name="save" size="md" color="white" />
                                    <span>Save</span>
                                </Button>
                            </div>
                        )}
                        {form.isSubmitting && <LinearProgress style={{ marginTop: 10 }} />}
                    </FormikForm>
                )}
            </Formik>
        </>
    );
}

Form.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    initialValues: PropTypes.shape({}),
    validationSchema: PropTypes.shape({}),
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    validateOnChange: PropTypes.bool,
    validateOnBlur: PropTypes.bool,
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showButtons: PropTypes.bool,
    id: PropTypes.string,
};

Form.defaultProps = {
    initialValues: {},
    validationSchema: undefined,
    onSubmit: () => {},
    onCancel: () => {},
    title: undefined,
    validateOnChange: false,
    validateOnBlur: false,
    maxWidth: "100%",
    showButtons: true,
    id: undefined,
};

export default Form;
